import React, { useState, useCallback, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Avatar, Menu, Dropdown, Icon, Badge, message, Button, Layout, Divider } from 'antd'
import { useMount } from 'react-use'
import cn from 'classnames'
import { NavLink, useHistory } from 'react-router-dom'
import * as userSelector from '@/models/user/selectors'
import * as notifySelector from '@/models/notifies/selectors'
import { logout, getCurrentUser } from '@/models/user/actions'
import * as managerActions from '@/models/managers/actions'
import * as globalSearchActions from '@/models/globalSearch/actions'
import * as tenantAction from '@/models/tenants/actions'
import * as couponsAction from '@/models/coupons/actions'
import styles from './styles.module.scss'
import getNavs from '@/navs'
import * as apis from '@/apis'
import { DownOutlined } from '@ant-design/icons';
import { fetchedNotify } from '@/models/notifies/actions'

const { SubMenu } = Menu;
const checkActive = nav => {
  const reg = new RegExp(`^${nav.to}`)
  return (_, location) => reg.test(location.pathname)
}

let firstCheckWorkingLock = false

export default function AppHeader(props) {
  const [navs, setNavs] = useState([])
  const [productTotal, setProductTotal] = useState(0)
  const user = useSelector(userSelector.getCurrentUser)
  const notifyCount = useSelector(notifySelector.notifyCountSelector)
  const todoRefreshKey = useSelector(userSelector.todoRefreshKeySelector);
  const dispatch = useDispatch()
  const history = useHistory();
  const logoutHandler = useCallback(() => dispatch(logout({ history })))
  const tenant = process.env.APP_MODE === 'tenant' && user.getIn(['staff', 'tenant'])
  //const tenantId = process.env.APP_MODE === 'tenant' && user.getIn(['staff', 'tenant', '_id'])
  const setManagerWorkingState = useCallback(() => {
    const id = user.getIn(['manager', '_id'])
    const isWorking = user.getIn(['manager', 'isWorking'])
    if (isWorking) {
      apis.offWork().then(() => {
        message.info('已停止接单')
        dispatch(getCurrentUser())
        dispatch(managerActions.updated(id, { isWorking: !isWorking }))
      })
        .catch(error => {
          message.error(error.message || '设置失败')
        })
    } else {
      apis.setWorkingState(id, {
        isWorking: !isWorking
      }).then(() => {
        if (isWorking) {
          message.info('已停止接单')
        } else {
          message.success('已开始接单')
        }

        dispatch(getCurrentUser())
        dispatch(managerActions.updated(id, { isWorking: !isWorking }))
      })
        .catch(error => {
          message.error(error.message || '设置失败')
        })
    }

  }, [user])
  const showTenantDialog = useCallback(() => {
    dispatch(tenantAction.showInfoDialog({
      id: tenant?._id
    }))
  })
  const showCouponsDialog = useCallback(() => {
    dispatch(couponsAction.showInfoDialog({
    }))
  })
  const showGlobalSearch = useCallback(() => {
    dispatch(globalSearchActions.toggleDialog())
  })

  const navToNotify = useCallback(() => {
    history.push('/notifyCenter')
  })
  useMount(() => {
    if (
      !firstCheckWorkingLock &&
      process.env.APP_MODE !== 'tenant' &&
      user.getIn(['manager', 'isWorking']) === false
      // TODO 管理员无需提醒
    ) {
      // setTimeout(() => {
      //   message.info('您还未开始接单，请记得开启', 5)
      // }, 1000)
    }
    firstCheckWorkingLock = true
    if (tenant) {
      dispatch(fetchedNotify());
    }

    if (process.env.APP_MODE !== 'tenant') {
      fetchAllProductTotal()
    }
  })

  const fetchAllProductTotal = () => {
    apis.findAllProductTotal().then(res => {
      setProductTotal(res.total)
    })
  }

  useEffect(() => {
    if (process.env.APP_MODE !== 'tenant') {
      if (todoRefreshKey !== 'initkey') {
        fetchAllProductTotal()
      }
    }
  }, [todoRefreshKey])

  useEffect(() => {
    const navs = getNavs(user.toJS())
    setNavs(navs)
  }, [user])

  useEffect(() => {
    history.listen((location) => {
      dispatch(getCurrentUser())
    })
  }, [])

  const menu = (
    <Menu>
      {/* {
        process.env.APP_MODE !== 'tenant' && user.get('manager') && !user.get('isTouer') && (
          <Menu.Item onClick={setManagerWorkingState} className={styles.dropDownMenuItem}>
            {
              user.getIn(['manager', 'isWorking']) ?
                <img src="/images/offwork.png" style={{ width: 18, height: 18, verticalAlign: 'top', margin: '1px 6px 0 0' }} /> :
                <Icon type="smile" style={{ fontSize: 18, marginRight: 6 }} />
            }
            <span>{user.getIn(['manager', 'isWorking']) ? '下班' : '开始接单'}</span>
          </Menu.Item>
        )
      } */}
      {process.env.APP_MODE == 'tenant' && user.get('originTenant') === 0 && <Menu.Item
        className={styles.dropDownMenuItem}
        onClick={() => {
          apis.exchangeAccount({ tenantId: user.getIn(['staff', 'tenant', '_id']), origin: 1 })
            .then(() => {
              message.success('账号切换成功')
              setTimeout(() => {
                location.reload()
              }, 600);
            })
            .catch(error => {
              message.error(error.message || '调用异常')
            })
        }}>
        <Icon type="rollback" style={{ fontSize: 18, marginRight: 6 }} />
        <span>返回账号</span>
      </Menu.Item>}

      <Menu.Item onClick={logoutHandler} className={styles.dropDownMenuItem}>
        <Icon type="poweroff" style={{ fontSize: 18, marginRight: 6 }} />
        <span>退出登录</span>
      </Menu.Item>
      {/* {
        process.env.APP_MODE == 'tenant' && user.get('isTouer') &&
        <Menu.Item onClick={showTenantDialog} className={styles.dropDownMenuItem}>
          <Icon type="profile" style={{ fontSize: 18, marginRight: 6 }} />
          <span>企业信息</span>
        </Menu.Item>
      }
      {
        process.env.APP_MODE == 'tenant' &&
        <Menu.Item onClick={showCouponsDialog} className={styles.dropDownMenuItem}>
          <Icon type="profile" style={{ fontSize: 18, marginRight: 6 }} />
          <span>代金券</span>
        </Menu.Item>
      } */}
    </Menu>
  )

  return (
    <Layout.Header style={{ background: '#fff', padding: 0 }}>
      <div className={styles.appheader}>
        <div className={styles.headerleft} style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          {process.env.APP_MODE == 'tenant' && <span style={{ fontSize: 16 }}>
            <span style={{ color: '#FF731B' }}>可用余额：{(user.getIn(['staff', 'tenant', 'balance']) - user.getIn(['staff', 'tenant', 'locked_balance']))?.toFixed(2)}</span>
            <Divider type="vertical" style={{ background: '#FF731B' }} />
            <span style={{ color: '#FF731B' }}>已冻结余额：{user.getIn(['staff', 'tenant', 'locked_balance'])?.toFixed(2)}</span>
            <Divider type="vertical" style={{ background: '#FF731B' }} />
            <span style={{ color: '#1890ff' }}>可用信用额度：{(user.getIn(['staff', 'tenant', 'total_credit']) - user.getIn(['staff', 'tenant', 'used_credits']) - user.getIn(['staff', 'tenant', 'locked_credits']))?.toFixed(2)}</span>
            <Divider type="vertical" style={{ background: '#FF731B' }} />
            <span style={{ color: '#1890ff' }}>信用额度：{user.getIn(['staff', 'tenant', 'total_credit'])?.toFixed(2)}</span>
            <Divider type="vertical" style={{ background: '#FF731B' }} />
            <span style={{ color: '#1890ff' }}>已冻结信用额度：{user.getIn(['staff', 'tenant', 'locked_credits'])?.toFixed(2)}</span>
            <Divider type="vertical" style={{ background: '#FF731B' }} />
            <span style={{ color: '#1890ff' }}>已使用信用额度：{(user.getIn(['staff', 'tenant', 'used_credits']))?.toFixed(2)}</span>
          </span>}
        </div>
        <div className={styles.headerright}>
          {process.env.APP_MODE == 'tenant' && <span style={{ marginRight: 20 }}>工单默认同意价格区间：{user.getIn(['staff', 'tenant', 'quotationStart'])} - {user.getIn(['staff', 'tenant', 'quotationEnd'])}</span>}
          {process.env.APP_MODE !== 'tenant' && <span style={{ marginRight: 20, cursor: 'pointer' }} onClick={() => { history.push('/productsPending') }}>待处理的产品视频：{productTotal}</span>}
          <span style={{ marginRight: 20 }}>客服电话：400-001-9693</span>
          {
            process.env.APP_MODE !== 'tenant' && user.get('manager') && (
              <Button onClick={setManagerWorkingState} style={{ marginRight: 10 }}>
                {
                  user.getIn(['manager', 'isWorking']) ?
                    <img
                      src="/images/offwork.png"
                      style={{ width: 16, height: 16, verticalAlign: 'top', margin: '1px 6px 0 0' }}
                    /> :
                    <Icon type="smile" style={{ fontSize: 18, marginTop: 3 }} />
                }
                <span>{user.getIn(['manager', 'isWorking']) ? '下班' : '开始接单'}</span>
              </Button>
            )
          }
          <Button
            onClick={showGlobalSearch}
            style={{ marginRight: 5 }}>
            <Icon type="search" style={{ fontSize: 16 }} />
            <span>快速搜索</span>
          </Button>

          {process.env.APP_MODE == 'tenant' && (
            <a className={styles.message} >
              <Badge count={notifyCount} size="small" onClick={navToNotify}>
                <Icon type="bell" style={{ fontSize: 24, color: '#333' }} />
              </Badge>
            </a>)
          }

          <div className={styles.right}>
            <Dropdown trigger={['click']} overlay={menu} placement="bottomRight">
              <div className={styles.userPanel}>
                <Avatar size="small" src={user.get('avatar')} className={styles.avatar} />
                {
                  process.env.APP_MODE !== 'tenant' && user.getIn(['manager', 'isWorking']) ? (
                    // <Badge count={<Icon type="clock-circle" style={{ fontSize: 20, color: '#fd8517' }} />}>
                    <span style={{ paddingRight: 15 }}>{user.get('name')}</span>
                    // </Badge>
                  ) : user.get('name')
                }
                <DownOutlined />
              </div>
            </Dropdown>
          </div>

        </div>
      </div>
    </Layout.Header>
  )
}